(function($){

  $(document).ready(function() {
  $('.single_bundle input[type="radio"]').on('change', function() {
    const parentRow = $(this).closest('.single_bundle_row');
   // parentRow.find('.single_bundle').removeClass('selected');
    $(this).closest('.single_bundle').addClass('selected');
  });
});


document.querySelectorAll('.single_bundle').forEach(bundle => {
  const image = bundle.querySelector('.sec_img');
  const radios = bundle.querySelectorAll('input[type="radio"]');

  radios.forEach(radio => {
    radio.addEventListener('change', e => {
      const label = bundle.querySelector(`label[for="${radio.id}"]`);
      const newSrc = label.getAttribute('data-src');
      if (newSrc && image) {
        image.src = newSrc;
      }
    });
  });
});



$(document).ready(function() {

  $(document).ready(function () {
  let currentPath = window.location.pathname; // e.g. /products/caramel-temptress
  $(".prod_nav a").each(function () {
    let href = $(this).attr("href");
    if (currentPath.includes(href.split('/products/')[1])) {
      $(this).addClass("active");
    }
  });
});


    $(".prod_nav a").each(function () {
  let href = $(this).attr("href");
  // Remove only the first matching suffix (-ps, -gf, -ct)
  let updatedHref = href.replace(/-(ps|gf|ct)/, '');
  $(this).attr("href", updatedHref);
});


    // $(".header_nav a[href*='-gf']").each(fugfion() {
    //     var href = $(this).attr("href");
    //     // Remove only the first occurrence of '-ps'
    //     var updatedHref = href.replace('-gf', '');
    //     $(this).attr("href", updatedHref);
    // });

});






$('.header__nav-button').click(function(){

  $('body').toggleClass('open-menu')

  $('.menu_wrap').toggleClass('open')

})

$('.page-overlay').click(function(){

  $('body').removeClass('open-menu')

  $('.menu_wrap').removeClass('open')
})

   $('.cart-link').click(function(){
    $('.g_side_cart').addClass('active');
    $('html').addClass('no-scroll');
      $('.overlay-page').addClass('active');
    })

$('.close_cart').click(function(){
  $('html').removeClass('no-scroll');
  $('.overlay-page').removeClass('active');
   $('.g_side_cart').removeClass('active')
})

$(document).on('click', '.overlay-page', function(){
 $('html').removeClass('no-scroll');
  $(this).removeClass('active');
  $('.g_side_cart').removeClass('active')
})



$('.col_banner_img').each(function(){

  $(this).find('img').hide();

  var _Bg = 'url('+ $(this).find('img').attr('src') + ')';

  $(this).css("background-image", _Bg);

  $(this).find('img').hide();

}); 

  $('.h-collection-list li a').on('click', function(){
		   	var target = $(this).attr('data-rel');
			$('.h-collection-list li a').removeClass('active');
		   	$(this).addClass('active');
		   	$("#"+target).fadeIn('slow').siblings(".tab-box").hide();
		   	return false;
  });


  $(window).scroll(function() {
  if ($(this).scrollTop() > 50) { // 👈 adjust scroll value (px)
    $('.header_wrap').addClass('scrolled');
  } else {
    $('.header_wrap').removeClass('scrolled');
  }
});








 $('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
    dots: false,
  fade: true,
  asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-for',
  arrows: true,
  dots: false,
    prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",
  centerMode: false,
  focusOnSelect: true,
  responsive: [
     {
      breakpoint: 767,
      settings: {
       arrows: false

      }
    },

  ]
});
	



$('.collection-slider').slick({
  dots: false,
   arrows: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000,
  speed: 700,
  cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
  pauseOnHover: true,
  prevArrow:"<button type='button' class='slick-prev small-icon'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='16' viewBox='0 0 52 16' fill='none'><path d='M51 7C51.5523 7 52 7.44772 52 8C52 8.55228 51.5523 9 51 9L51 8L51 7ZM0.292892 8.7071C-0.0976296 8.31658 -0.0976295 7.68341 0.292893 7.29289L6.65686 0.928928C7.04738 0.538404 7.68055 0.538404 8.07107 0.928928C8.46159 1.31945 8.46159 1.95262 8.07107 2.34314L2.41422 8L8.07107 13.6569C8.46159 14.0474 8.46159 14.6805 8.07107 15.0711C7.68055 15.4616 7.04738 15.4616 6.65686 15.0711L0.292892 8.7071ZM51 8L51 9L1 9L1 8L1 7L51 7L51 8Z' fill='currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='16' viewBox='0 0 52 16' fill='none'><path d='M1 7C0.447715 7 -4.82823e-08 7.44772 0 8C4.82823e-08 8.55228 0.447715 9 1 9L1 8L1 7ZM51.7071 8.7071C52.0976 8.31658 52.0976 7.68341 51.7071 7.29289L45.3431 0.928928C44.9526 0.538404 44.3195 0.538404 43.9289 0.928928C43.5384 1.31945 43.5384 1.95262 43.9289 2.34314L49.5858 8L43.9289 13.6569C43.5384 14.0474 43.5384 14.6805 43.9289 15.0711C44.3195 15.4616 44.9526 15.4616 45.3431 15.0711L51.7071 8.7071ZM1 8L1 9L51 9L51 8L51 7L1 7L1 8Z' fill='currentcolor'/></svg></button>",
  slidesToShow:5,
  centerMode: true,
        centerPadding: '180px',
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow:3,
        arrows: true,
         centerPadding: '28px',

      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow:2,
        arrows: true,
         centerPadding: '28px',

      }
    },
    {

      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        arrows: true,
         centerPadding: '32px',

      }

    }

  ]

});


 jQuery('.video-background').parent().click(function () {
	if ($(this).children(".video-background").get(0).paused) {
		$(this).children(".video-background").get(0).play(); $(this).children(".playpause").fadeOut();
	} else {
		$(this).children(".video-background").get(0).pause();
		$(this).children(".playpause").fadeIn();
	}
});

$(".qty-box .qty__adjust").on("click", function () {
  var t,
      e = $(this),
      i = e.parents(".qty-box").find("input").val();
  (t = e.hasClass("qty__adjust--plus") ? parseFloat(i) + 1 : 0 <= i ? parseFloat(i) - 1 : 1), e.parents().find("input").val(t);
});


if (window.matchMedia("(min-width: 767px)").matches) {

document.addEventListener("DOMContentLoaded", function () {
   setTimeout(() => {
  const mainItems = document.querySelectorAll(".product_for .item");
  const thumbs = document.querySelectorAll(".product_thumb .item");

  function setActiveThumb(index) {
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle("active", i === index);
    });
  }

  // Force first thumb active initially
  setActiveThumb(0);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Array.from(mainItems).indexOf(entry.target);
          setActiveThumb(index);
        }
      });
    },
    {
      root: null,
      threshold: 0.3, // slightly lower for better detection
    }
  );

  mainItems.forEach((item) => observer.observe(item));

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      mainItems[index].scrollIntoView({ behavior: "smooth", block: "center" });
      setActiveThumb(index);
    });
  });
   }, 2000);
});
}

if (window.matchMedia("(max-width: 767px)").matches) {
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
  const mainItems = document.querySelectorAll(".product_for .item");
  const thumbs = document.querySelectorAll(".product_thumb .item");

  function setActiveThumb(index) {
    thumbs.forEach((t, i) => t.classList.toggle("active", i === index));
  }

  // Force first thumb active
  setActiveThumb(0);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Array.from(mainItems).indexOf(entry.target);
          setActiveThumb(index);
        }
      });
    },
    {
      root: null,
      threshold: 0.1,
      rootMargin: "0px 0px -50% 0px" // 🔥 triggers earlier
    }
  );

  mainItems.forEach((item) => observer.observe(item));

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => {
      mainItems[index].scrollIntoView({ behavior: "smooth", block: "center" });
      setActiveThumb(index);
    });
  });
   }, 2000);
});

}


window.addEventListener('scroll', function () {
  const sticky = document.querySelector('.product_thumb');
  const container = document.querySelector('.product_media'); // removed extra space

  if (!sticky || !container) return;

  const scrollTop = window.scrollY;
  const stickyHeight = sticky.offsetHeight;
  const containerTop = container.offsetTop;
  const containerHeight = container.offsetHeight;

  // Bottom boundary (minus 200px)
  const containerBottom = containerTop + containerHeight - 200;

  // If scrollTop is within container range
  if (scrollTop >= containerTop && scrollTop + stickyHeight < containerBottom) {
    sticky.classList.add('fixed');
    sticky.classList.remove('bottom');
  }
  // If sticky is within 200px of the bottom
  else if (scrollTop + stickyHeight >= containerBottom) {
    sticky.classList.remove('fixed');
    sticky.classList.add('bottom');
  }
  // If above container
  else {
    sticky.classList.remove('fixed');
    sticky.classList.remove('bottom');
  }
});







$('.toggle-ing').click(function() {
  $('.ingredient_box').toggle(500);
   $(this).toggleClass('active');
});





$('.seach_icon').click(function() {
  $('body').addClass('search-open');
  $('#goal').focus(); 
});

$(document).on('click', '.search_close', function(){
 $('body').removeClass('search-open');
})

setTimeout(function() {
    var loader = document.getElementById('page-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  }, 3000);




document.addEventListener("DOMContentLoaded", function () {
  const hash = window.location.hash.replace('#', '');

  if (!hash) return;

  const tabButton = document.querySelector(`.header_nav_wrap li#${hash} a`);

  if (tabButton) {
    const target = tabButton.getAttribute("data-rel");

    document.querySelectorAll('.header_nav_wrap li a')
      .forEach(a => a.classList.remove('active'));

    tabButton.classList.add('active');

    document.querySelectorAll('.home_collection').forEach(box => {
      box.style.display = "none";
    });

    const content = document.querySelector(`#${target}`);
    if (content) {
      content.style.display = "block";

      // Scroll with top offset -130px
      setTimeout(() => {
        const rect = content.getBoundingClientRect().top + window.pageYOffset;
        const offset = rect - 130;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }, 200);
    }
  }
});



})(jQuery);



